import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from "react";

const getOptionLabel = (option) => {
    if (option == null) return "";
    if (typeof option === "string") return option;
    return option.label || option.title || option.value || "";
};

const isOptionEqualToValue = (option, value) => {
    if (value == null || value === "") return false;
    if (typeof option === "string" || typeof value === "string") {
        return option === value;
    }
    return (
        option?.value === value?.value ||
        option?.label === value?.label ||
        option?.title === value?.title
    );
};

export default function FormAutoCompleted({ label, labelVarient = "label", props = {} }) {
    const {
        value,
        options = [],
        error,
        helperText,
        onChange,
        ...rest
    } = props;

    // Autocomplete rejects "" when it is not in options — normalize to null
    const normalizedValue = value === "" || value === undefined ? null : value;

    return (
        <Stack direction={"column"} spacing={1}>
            <Typography variant={labelVarient}>{label}</Typography>
            <Autocomplete
                value={normalizedValue}
                options={options}
                onChange={onChange}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={isOptionEqualToValue}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        error={error}
                        helperText={helperText}
                        sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                                height: 50,
                                fontSize: "1rem",
                            },
                        }}
                    />
                )}
                popupIcon={
                    <Box sx={{ width: 24, height: 24 }}>
                        <ExpandMoreIcon sx={{ width: 18, height: 18, color: "text.disabled" }} />
                    </Box>
                }
                {...rest}
            />
        </Stack>
    );
}
